<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
  <g id="g45">
    <rect style="fill: #2ab296;" y="0" x="0" rx="6" height="12" width="12" />
    <path
      style="fill: none; stroke: #ffffff; stroke-width: 1.5; stroke-linecap: round;"
      d="m 2.9508047,6.414837 1.756,1.7560002 L 8.950805,3.926837"
    />
  </g>
</svg>
